import React from "react";
import Logo from "../Logo/Logo";
import Avatar from "../Avatar/Avatar";
import styles from "./Header.module.css";

export default function Header(props) {
	return (
		<header className={styles.header}>
			<div className={styles.left}>
				<Logo />
			</div>
			<div className={styles.middle}>{props.children}</div>
			<div className={styles.right}>
				<Avatar />
			</div>
		</header>
	);
}
